module.exports = __webpack_public_path__ + "static/media/bg-spacer-palm.c2553cec.svg";